import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Tag' })({
    root: {
        padding: '4px 12px',
        borderRadius: 96,
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '16px',
        cursor: 'default',
        textDecoration: 'none'
    },
    _interactive: {
        cursor: 'pointer',
        transition: 'opacity 0.25s',
        '&:hover': {
            opacity: 0.75
        }
    },
    _default: {
        color: '#232323',
        background: '#F8F8F8'
    },
    _blue: {
        color: '#4180F0',
        background: '#E3F2FF'
    }
});
